import scheduleApi from '@/api/schedule';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    data:null,
    segmentsData:null
}

export const mutationTypes = {
    getScheduleStart: '[schedule] Get schedule start',
    getScheduleSuccess: '[schedule] Get schedule success',
    getScheduleFailure: '[schedule] Get schedule failure',

    getScheduleDutyStart: '[schedule] Get schedule duty start',
    getScheduleDutySuccess: '[schedule] Get schedule duty success',
    getScheduleDutyFailure: '[schedule] Get schedule duty failure',

    getStaffSegmentsStart: '[schedule] Get staff segments start',
    getStaffSegmentsSuccess: '[schedule] Get staff segments success',
    getStaffSegmentsFailure: '[schedule] Get staff segments failure',
}

export const scheduleActionTypes = {
    getSchedule: '[schedule] Get schedule',
    getScheduleDuty: '[schedule] Get schedule duty',
    getStaffSegments: '[schedule] Get staff segments'
}

const mutations = {
    [mutationTypes.getScheduleStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getScheduleSuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.getScheduleFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getScheduleDutyStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getScheduleDutySuccess](state, payload) {
        state.isLoading = false
        state.data = payload
        state.validationErrors = null
    },
    [mutationTypes.getScheduleDutyFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getStaffSegmentsStart](state) {
        state.isLoading = true
        state.validationErrors = null
    },
    [mutationTypes.getStaffSegmentsSuccess](state, payload) {
        state.isLoading = false
        state.segmentsData = payload
        state.validationErrors = null
    },
    [mutationTypes.getStaffSegmentsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
}

const actions = {
    [scheduleActionTypes.getSchedule](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getScheduleStart)
            scheduleApi
                .getSchedule(data)
                .then(response => {
                    context.commit(mutationTypes.getScheduleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getScheduleFailure,response)
                })
        })
    },
    [scheduleActionTypes.getScheduleDuty](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getScheduleDutyStart)
            scheduleApi
                .getScheduleDuty(data)
                .then(response => {
                    context.commit(mutationTypes.getScheduleDutySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getScheduleDutyFailure,response)
                })
        })
    },
    [scheduleActionTypes.getStaffSegments](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getStaffSegmentsStart)
            scheduleApi
                .getStaffSegments(data)
                .then(response => {
                    context.commit(mutationTypes.getStaffSegmentsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getStaffSegmentsFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}